import type {
  CompleteStockTakeInput, CreateStockTakeInput, StockTakeCountInput,
  StockTakeDetail, StockTakeListItem,
} from '@najah/core'
import { api } from './api'

export const stockTakeApi = {
  list: () => api<StockTakeListItem[]>('/stock-takes'),
  findOne: (id: string) => api<StockTakeDetail>(`/stock-takes/${id}`),
  create: (body: CreateStockTakeInput) =>
    api<StockTakeDetail>('/stock-takes', { method: 'POST', body }),
  recordCounts: (id: string, body: StockTakeCountInput) =>
    api<StockTakeDetail>(`/stock-takes/${id}/counts`, { method: 'PATCH', body }),
  complete: (id: string, body: CompleteStockTakeInput) =>
    api<StockTakeDetail & { adjustedCount: number }>(`/stock-takes/${id}/complete`, { method: 'POST', body }),
  cancel: (id: string) => api<{ success: boolean }>(`/stock-takes/${id}/cancel`, { method: 'POST' }),
}
